import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useDrive from "../../hooks/useDrive";
import {useEffect, useState} from "react";
import AppStlView from "../AppStlView";
import styles from "./file-view-modal.module.css";
import unknownIcon from "../../asset/icons/unknown-icon.png";
import FileService from "../../services/FileService";
import {DialogActions, IconButton} from "@mui/material";
import {Close} from "@mui/icons-material";
import DriveRowActionCell from "../DriveRow/DriveRowActionCell";
import Typography from '@mui/material/Typography';
import folderIcon from "../../asset/icons/folder.png";

export default function FileViewModal() {
    const {CurrentDrive, previewObject, changePreviewObject, selectedRow} = useDrive();
    const [downloadURL, setDownloadURL] = useState(null);

    useEffect(() => {
        setDownloadURL('');
        if (previewObject && previewObject.type && previewObject.type === 'file') {
            getDownloadUrl();
        }
    }, [previewObject])

    const handleClose = () => {
        // console.log(previewObject);
        changePreviewObject(null);
    };

    const getDownloadUrl = async () => {
        // console.log("selected for download", previewObject);
        const {parent, driveType} = CurrentDrive;
        const url = await FileService.getDownLoadLink(parent, previewObject.Key, driveType);
        // console.log(url)
        if (url) {
            setDownloadURL(url.url || url);
        }

    }
    const loadFile = () => {
        if (!previewObject) {
            return '';
        }
        const {Key} = previewObject;
        const x = Key.split(".");
        const fileType = x.pop().toLowerCase();

        if(selectedRow.type === 'folder') {
            return  <img
            className={styles.folderThumb}
            src={folderIcon}
            alt="Folder icon"
        />
        }
        
        switch (fileType) {
            case "obj":
            case "stl":
                return <AppStlView  src={downloadURL} fileType={fileType} styles={{textAlign: "center", height: "100%"}}/>
            case "png":
            case "jpeg":                
            case "jpg":
            case "ico":
                return <img
                    className={styles.image}
                    src={downloadURL}
                    alt="file"
                />
            // case "mp4":
            //     return <video width="320" height="240" autoPlay muted>
            //                 <source src={downloadURL} type="video/mp4"/>
            //                 <source src={downloadURL} type="video/ogg"/>
            //                     Your bselectedRowser does not support the video tag
            //             </video>
            default:
                return <img
                    className={styles.folderThumb}
                    src={unknownIcon}
                    alt="Folder icon"
                />
        }

    }
    return (
        <React.Fragment>

            <Dialog
                fullWidth={true}
                maxWidth={"md"}
                open={!!previewObject}
                onClose={handleClose}
                className={styles.root}
            >
                <DialogTitle sx={{m: 0, p: 2}}>
                <Typography variant="h5" component="div" style={{textAlign: "center"}}> {selectedRow ? selectedRow.Key : ''} </Typography>
                
                    <IconButton
                        size={"small"}
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            background: '#fff',
                            position: 'absolute',
                            right: 0,
                            top: 0,
                        }}
                    >
                        <Close/>
                    </IconButton>
                </DialogTitle>
                <DialogContent className={styles.dialogContent}>


                    <div className={styles.stlMediaContainer}>
                        {loadFile()}
                        {/* <Typography variant="h5" component="div" style={{textAlign: "center"}}> {selectedRow ? selectedRow.Key : ''} </Typography>
            <Typography variant="caption" display="block" gutterBottom  style={{textAlign: "center"}}>{selectedRow && selectedRow.LastModified ? <Moment format="YYYY-MM-DD HH:mm:ss">{selectedRow.LastModified}</Moment> : ''}</Typography>
                {selectedRow ?    <div className={styles.mediaContainer}>
                                <FileMedia />
                            </div> : ""}

                             */}
                            
                    </div>
                </DialogContent>
                <DialogActions>
                <div className={styles.actionContainer} >
                                <DriveRowActionCell cell={false} row={selectedRow} />
                            </div>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
